import React, { useEffect, useState } from "react";

import { ReactComponent as TitleIcon } from "../../../imgs/icons/chat.svg";
import CreateUpdateIntentModalBody from "../../../components/CreateUpdateIntentModalBody";
import Modal from "../../../components/Modal";

const EditIntentModal = ({
  intentId,
  isOpen,
  onClose,
  onSuccess,
  setLoading,
  api,
  loading,
}) => {
  const [intent, setIntent] = useState({
    type: "",
    description: "",
    category: "Order Management",
    response: "",
    email_collect: false,
    hand_off: false,
    set_live: false,
  });

  const fetchIntent = async () => {
    const chatbotUuid = localStorage.getItem("chatbot_uuid");
    if (!chatbotUuid) {
      console.error("Chatbot UUID not found");
      return;
    }
    try {
      setLoading(true);
      const { data } = await api.get(`/api/intents/${intentId}`, {
        params: {
          chatbot_uuid: chatbotUuid,
        },
      });

      setIntent(data);
    } catch (err) {
      console.error("Failed to fetch intent", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      fetchIntent(intentId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [intentId, isOpen]);

  const actionDisabled =
    !intent.type || !intent.description || !intent.category || !intent.response;

  const handleInputChange = (field, value) => {
    setIntent(prevState => ({
      ...prevState,
      [field]: value,
    }));
  };

  const saveIntent = async e => {
    try {
      e.preventDefault();

      setLoading(true);

      const chatbotUuid = localStorage.getItem("chatbot_uuid");

      await api.put(`/api/intents/${intentId}`, {
        ...intent,
        chatbot_uuid: chatbotUuid,
      });

      onSuccess();
    } catch (err) {
      console.error("Failed to update intent", err);
    }
  };

  return (
    <Modal
      isSubmitting={loading}
      disabled={actionDisabled}
      open={isOpen}
      onClose={onClose}
      onSubmit={saveIntent}
      title="Edit Intent"
      tooltip={
        <div className="max-w-sm">
          Intents are used by your AI Agent to understand a specific customer
          intent and how to react in those situations.
        </div>
      }
      startIcon={
        <TitleIcon width={45} height={45} className="p-2 border rounded-xl" />
      }
    >
      <CreateUpdateIntentModalBody
        handleInputChange={handleInputChange}
        intent={intent}
        showTooltips={isOpen}
      />
    </Modal>
  );
};

export default EditIntentModal;
